import { put } from 'redux-saga/effects'
import { fetchOperatorsAction } from '../../actions'
import { fetchOperators, FetchOperatorsResponse } from '../_http/user'

export function* fetchOperatorsSaga(action: ReturnType<typeof fetchOperatorsAction.request>) {
  try {
    const { companyId, ownerId, isWork } = action.payload
    const response: FetchOperatorsResponse = yield fetchOperators({ companyId, ownerId, isWork })
    yield put(fetchOperatorsAction.success({ users: response.operators }))
  } catch (error) {
    console.log({ fetchOperatorsSagaError: error })
    yield put(fetchOperatorsAction.failure())
  }
}
